/* eslint-disable jsx-a11y/alt-text */
import { mask } from "../assets";

const Cardoverlayevry = params => {
  return (
    <>
    <div  className="modal fade" id="cardOverlay2" tabIndex="-1" aria-labelledby="cardOverlayModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">

          <div className="modal-header hide">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span className="close-btn" aria-hidden="true">
                &times;
              </span>
            </button>
          </div>

          <div className="modal-body padding-0">

    <div className="backcardlay">
      <div className="container overlay-1">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="card overlay-card-1 ">
            <header className="overlay1-1-header">
              <h5 className="line-height memphis-medium color-mistake-pay">
                You get a text message from your doctor's office that it's time
                for your annual physical.You feel fine.
              </h5>
              <h1 className="text-right tect-white overy-everyone Pacifico-Regulars">
                everyone!
              </h1>
            </header>
            <div className="col-md-12">
              <h5 className="w-set-check mt-1 botton-regular">You...</h5>
              <label className="container w-checkox mt-3 memphis-medium color-mistake-pay">
                Miss two hours of work to go to the appointment
                <input name="cardoverlay1_option[]" onChange={(e) => params.checkCardOverlay(e.target, 2, 4)} type="radio" />
                <span className="checkmark"></span>
              </label>
              <div className="overlay-plus-top">
                <p className="w-83 text-color-grey m-auto Pacifico-Regulars">
                  lose <img src={mask} className="width-ovwelay-image" />{" "}
                  work/job
                </p>
              </div>
              <h5 className="w-set-check mt-3 botton-regular">OR:</h5>
              <label className="container  w-checkox mt-3 memphis-medium color-mistake-pay">
                Skip it, but worry that you should have gone.
                <input name="cardoverlay1_option[]" onChange={(e) => params.checkCardOverlay(e.target, 2, 2)} type="radio" />
                <span className="checkmark"></span>
              </label>
              <div className="overlay-plus-top">
                <p className="w-83 text-color-grern m-auto Pacifico-Regulars">
                  lose <img src={mask} className="width-ovwelay-image" />{" "}
                  home/family
                </p>
              </div>
            </div>
            <div className="col-md-12 text-right  margin-health-economy">
              <h6 className="health-overlay-color font-economy memphis-medium">&copy;<span className="ml-1">Health Economy 2019</span></h6>
            </div>
          </div>
          <div className="mt-4">
            <div className="card-overlay-2 bg-overlay">
              <div className="text-center">
                <button onClick={(e) => params.keepOpen(e.target, 2)} type="text" className="overlay-button">
                  Keep Open
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
          </div>
        </div>
      </div>
    </div>


    </>
  );
};

export default Cardoverlayevry;
